/**
 * Validates the form data and returns any validation errors
 */
export const validateForm = (formData) => {
    const errors = {};
  
    // Required fields
    if (!formData.name.trim()) {
      errors.name = "Name cannot be empty";
    }
  
    if (!formData.email_Id.trim()) {
      errors.email_Id = "Email cannot be empty";
    } else if (!/\S+@\S+\.\S+/.test(formData.email_Id)) {
      errors.email_Id = "Please provide a valid email address";
    }
  
    if (!formData.contactNo.trim()) {
      errors.contactNo = "Contact number cannot be empty";
    } else if (!/^\d{10}$/.test(formData.contactNo.replace(/\D/g, ''))) {
      errors.contactNo = "Please provide a valid 10-digit contact number";
    }
  
    if (!formData.branch) {
      errors.branch = "Branch cannot be empty";
    }
  
    // Validate passedout year if provided
    if (formData.passedout) {
      if (isNaN(formData.passedout)) {
        errors.passedout = "Passed out year must be a number";
      } else {
        const year = parseInt(formData.passedout);
        const currentYear = new Date().getFullYear();
        
        if (year < 1950 || year > currentYear + 5) {
          errors.passedout = `Year must be between 1950 and ${currentYear + 5}`;
        }
      }
    }
  
    return errors;
  };